import type { DonationCampaign, MerchProduct } from '../index.js';

export const merchSeed: MerchProduct[] = [
  {
    sku: 'MERCH-01',
    name: { fr: 'T-shirt Juvo Geek', en: 'Juvo Geek t-shirt' },
    description: {
      fr: 'Coton, logo sérigraphié. Les recettes financent l’atelier.',
      en: '100% cotton, screen-printed logo.',
    },
    priceUsd: 18,
    image:
      'https://images.unsplash.com/photo-1521572163474-6864f9cf17ab?q=80&w=800&auto=format&fit=crop',
  },
  {
    sku: 'MERCH-02',
    name: { fr: 'Tote refurb', en: 'Refurb tote bag' },
    description: {
      fr: 'Fabriqué à partir de matériaux récupérés à l’atelier.',
      en: 'Made from recovered workshop materials.',
    },
    priceUsd: 12,
    image:
      'https://images.unsplash.com/photo-1590874103328-eac38a941954?q=80&w=800&auto=format&fit=crop',
  },
  {
    sku: 'MERCH-03',
    name: { fr: 'Set de pins Juvo', en: 'Juvo enamel pin set' },
    description: {
      fr: 'Badges Circular, Academy et JVC.',
      en: 'Circular, Academy, and JVC badges.',
    },
    priceUsd: 9,
    image:
      'https://images.unsplash.com/photo-1572021335469-31706a17aaef?q=80&w=800&auto=format&fit=crop',
  },
];

export const donationCampaignSeed: DonationCampaign = {
  kgRefurbished: 0,
  devicesThisQuarter: 0,
  fundsRaisedUsd: 0,
  fundsTargetUsd: 8000,
};
